'use client'
import { FC } from 'react'
import cn from 'classnames'
import styles from './User.module.scss'
import { Icon } from '@/icons'
import { observer } from 'mobx-react-lite'
import { userStore } from '@/domains/WebApp/store/User'
import { BRANDSIDE_SERVICE_URL } from '@/config/site'
import { widgetStore } from '@/domains/WebApp/store/Widget'

interface UserProps {
  className?: string
}
export const User: FC<UserProps> = observer(({ className }) => {
  if (widgetStore.isWidget) {
    return null
  }

  if (userStore.isRegistered) {
    return (
      <div className={cn(styles.container, className)}>
        <Icon name="user" className={styles.iconUser} />
        <span className={styles.name}>Константин К</span>
      </div>
    )
  } else {
    return (
      <a
        href={`${BRANDSIDE_SERVICE_URL}/auth/login`}
        target="_blank"
        className={cn(styles.container, className)}
      >
        <Icon name="user" className={styles.iconUser} />
        <span className={styles.name}>Войти в аккаунт</span>
      </a>
    )
  }
})
